import { type UseQueryResult, useQuery } from 'react-query';
import { EmployeeTypeService } from '../../services/wealthlane-customer-services';

const useGetAllEmployeeType = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const allEmployeeTypeOptions = useQuery(
    ['getAllEmployeeTypeOptions'],
    async () => {
      return await handleRequest(
        EmployeeTypeService.getApiCustomerApiAppEmployeeTypeEmployeeTypes()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return allEmployeeTypeOptions;
};

export default useGetAllEmployeeType;
